export function StepHeader({ step, total = 5, title, description }) {
  return (
    <div className="mb-10">
      <p className="mb-3 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
        STEP {step} OF {total}
      </p>
      <h1 className="mb-2 text-3xl font-bold tracking-tight text-foreground">{title}</h1>
      <p className="text-base text-muted-foreground">{description}</p>
    </div>
  )
}
